export const agentTransType = [{ TypesID: 0, TypesName: 'All' }, { TypesID: 1, TypesName: 'Booked' }, { TypesID: 2, TypesName: 'Cancelled' }, { TypesID: 3, TypesName: 'Recharges' }]
export const usercollFilterCol = [
    { header: 'User', dataKey: 'user', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 4 } },
    { header: 'Journey Date', dataKey: 'journeyDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 4 } },
    { header: 'Report Generation Date', dataKey: 'reportDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
]
export const agentTxnFilterCol = [
    { header: 'Date', dataKey: 'date', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
    { header: 'Operator', dataKey: 'operators', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
    { header: 'Type', dataKey: 'types', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
    { header: 'Report Generation Date', dataKey: 'reportDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
]
export const userCollectionColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'User', field: 'UserName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Ticket No', field: 'TicketNo', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Operator', field: 'CompanyName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', }
    },
    {
        headerName: 'JDate', field: 'Jdate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'JTime', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'From', field: 'FromCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'To', field: 'ToCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Seats', field: 'Seatcount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Comm', field: 'AgentComm', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Total', field: 'TotalFare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },
]
export const agentTxnColDef = [
    {
        headerName: 'Sr.', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'Trans.Date', field: 'TxnDate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'Agent Name', field: 'AgentName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '60px' }
    },
    {
        headerName: 'Particulars', field: 'Particulars', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'JDate', field: 'JDate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '90px' }
    },
    {
        headerName: 'JTime', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '90px' }
    },
    {
        headerName: 'Type', field: 'Type', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '90px' }
    },
    {
        headerName: 'Opening Bal.', field: 'OpeningBalance', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Debit', field: 'NetAmtDebit', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Credit', field: 'NetAmtCredit', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Closing Bal.', field: 'ClosingBalance', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '90px' }
    },
]

export const userCollectionTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 8, headerSx: { textAlign: 'left', } },
    { headerName: 'Seats', field: 'Seatcount', headerSx: { textAlign: 'right', } },
    { headerName: 'Comm', field: 'AgentComm', headerSx: { textAlign: 'right', } },
    { headerName: 'Total', field: 'TotalFare', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'right', } },

]


export const userCollectionRefundColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'User', field: 'UserName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Ticket No', field: 'TicketNo', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Operator', field: 'CompanyName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', }
    },
    {
        headerName: 'JDate', field: 'Jdate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'JTime', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'From', field: 'FromCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'To', field: 'ToCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Seats', field: 'Seatcount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Charge', field: 'charge',
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 15 },
        headerSx: { textAlign: 'number', width: '100px' }
    },
    {
        headerName: 'Total', field: 'TotalFare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },

]


export const userCollectionRefundTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 8, headerSx: { textAlign: 'left', } },
    { headerName: 'Seats', field: 'Seatcount', headerSx: { textAlign: 'right', } },
    { headerName: 'Charge', field: 'charge', headerSx: { textAlign: 'right', } },
    { headerName: 'Total', field: 'TotalFare', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'left', } },

]

export const userCollSummaryColDef = [
    {
        headerName: 'Type', field: 'type', headerSx: { textAlign: 'left', },
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }
    },
    {
        headerName: 'Recived', field: 'Recived', headerSx: { textAlign: 'right', width: '150px' },
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }
    },
    {
        headerName: 'Payment', field: 'Payment', headerSx: { textAlign: 'right', width: '150px' },
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }
    },
]

export const userCollSummaryTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 2, headerSx: { textAlign: 'left', } },
    { headerName: 'Payment', field: 'Payment', headerSx: { textAlign: 'right', width: '150px' } },
]


export const branchOffRefundColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'User', field: 'UserName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Ticket No', field: 'TicketNo', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Operator', field: 'CompanyName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', }
    },
    {
        headerName: 'JDate', field: 'Jdate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'JTime', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'From', field: 'FromCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'To', field: 'ToCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Seats', field: 'Seatcount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Comm', field: 'AgentComm', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Total', field: 'TotalFare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '100px' }
    },

    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },
]

export const branchOffRefundTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 8, headerSx: { textAlign: 'left', } },
    { headerName: 'Seats', field: 'Seatcount', headerSx: { textAlign: 'right', } },
    { headerName: 'Comm', field: 'AgentComm', headerSx: { textAlign: 'right', } },
    { headerName: 'Total', field: 'TotalFare', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'left', } },
]


export const branchOffRefundDetailsColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'User', field: 'UserName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Ticket No', field: 'TicketNo', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Operator', field: 'CompanyName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', }
    },
    {
        headerName: 'JDate', field: 'Jdate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'JTime', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'From', field: 'FromCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'To', field: 'ToCityNameShort', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Seats', field: 'Seatcount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '90px' }
    },
    {
        headerName: 'Charge', field: 'Charge',
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 15 },
        headerSx: { textAlign: 'number', width: '100px' }
    },
    {
        headerName: 'Total', field: 'TotalFare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 15 }, headerSx: { textAlign: 'right', width: '100px' }
    },

    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },

]

export const branchOffRefundDetailsTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 8, headerSx: { textAlign: 'left', } },
    { headerName: 'Seats', field: 'Seatcount', headerSx: { textAlign: 'right', } },
    { headerName: 'Charge', field: 'Charge', headerSx: { textAlign: 'right', } },
    { headerName: 'Total', field: 'TotalFare', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'left', } },

]





export const userCollBranchOffSummaryColDef = [
    {
        headerName: 'Type', field: 'type', headerSx: { textAlign: 'left', },
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 10 }
    },
    {
        headerName: 'Recived', field: 'Recived', headerSx: { textAlign: 'right', width: '150px' },
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }
    },
    {
        headerName: 'Payment', field: 'Payment', headerSx: { textAlign: 'right', width: '150px' },
        pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }
    },
]

export const userCollBranchOffSummaryTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 2, headerSx: { textAlign: 'left', } },
    { headerName: 'Payment', field: 'Payment', headerSx: { textAlign: 'right', width: '150px' } },
]



export const agentTicketFilterCol = [
    { header: 'Type', dataKey: 'type', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 5 } },
    { header: 'Journey Date', dataKey: 'journeyDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 5 } },
    { header: 'Report Generation Date', dataKey: 'reportDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 5 } },
    { header: 'Operator', dataKey: 'operator', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 4 } },

]



export const agentTicketColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'T.Code', field: 'TripCode', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'B Date', field: 'BookingDateFormated', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'J date', field: 'JourneyDate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 },
        headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'J Time', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Route', field: 'SubRouteName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'BusNumber', field: 'BusNumber', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Seat\nNos.', field: 'SeatNos', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '180px' }
    },
    {
        headerName: 'PNR-TKT', field: 'pnrTicket', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '200px' }
    },
    {
        headerName: 'OrderID', field: 'OrderID', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'Customer\nName', field: 'PassengerName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'Contact\nNo.', field: 'PassengerContactNo1', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '110px' }
    },
    {
        headerName: 'Pick Up', field: 'PickupName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'Seats', field: 'SeatCount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '60px' }
    },
    {
        headerName: 'Amount', field: 'amount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },

    {
        headerName: 'BkgChargs', field: 'BkgChargs', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Discount', field: 'discount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'GST', field: 'GST', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Net.', field: 'net', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '120px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },

]

export const agentTicketTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 13, headerSx: { textAlign: 'left', } },
    { headerName: 'Seat', field: 'SeatCount', headerSx: { textAlign: 'right', } },
    { headerName: 'Amount', field: 'amount', headerSx: { textAlign: 'right', } },
    { headerName: 'BkgChargs', field: 'BkgChargs', headerSx: { textAlign: 'right', } },
    { headerName: 'Discount', field: 'discount', headerSx: { textAlign: 'right', } },
    { headerName: 'GST', field: 'GST', headerSx: { textAlign: 'right', } },
    { headerName: 'Net', field: 'net', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'left', } },

]



export const agentTicketRefundColDef = [
    {
        headerName: 'Sr', field: 'SrNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '40px' }
    },
    {
        headerName: 'T.Code', field: 'TripCode', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '80px' }
    },

    {
        headerName: 'J date', field: 'JourneyDate', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 },
        headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'J Time', field: 'JTime', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Route', field: 'SubRouteName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'BusNumber', field: 'BusNumber', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Seat\nNos.', field: 'SeatNos', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '180px' }
    },
    {
        headerName: 'PNR-TKT', field: 'pnrTicket', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '200px' }
    },

    {
        headerName: 'Customer\nName', field: 'PassengerName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'Contact\nNo.', field: 'PassengerContactNo1', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '110px' }
    },
    {
        headerName: 'Booking\nDate', field: 'BookingDateFormated', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Cancel\nDate', field: 'CancelDateFormated', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Seats', field: 'SeatCount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '80px' }
    },
    {
        headerName: 'Amount', field: 'amount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },

    {
        headerName: 'Comm', field: 'AgentComm', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },

    {
        headerName: 'Discount', field: 'discount', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'CC Operator', field: 'charge', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'GST', field: 'GST', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Net.', field: 'net', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
        headerSx: { textAlign: 'right', width: '100px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },

]


export const agentTicketRefundTotalColDef = [
    { headerName: 'lable', field: 'totalCaption', colSpan: 12, headerSx: { textAlign: 'left', } },
    { headerName: 'Seat', field: 'SeatCount', headerSx: { textAlign: 'right', } },
    { headerName: 'Amount', field: 'amount', headerSx: { textAlign: 'right', } },
    { headerName: 'Comm', field: 'AgentComm', headerSx: { textAlign: 'right', } },
    { headerName: 'Discount', field: 'discount', headerSx: { textAlign: 'right', } },
    { headerName: 'Operator', field: 'charge', headerSx: { textAlign: 'right', } },
    { headerName: 'GST', field: 'GST', headerSx: { textAlign: 'right', } },
    { headerName: 'Net', field: 'net', headerSx: { textAlign: 'right', } },
    { headerName: '', field: '', headerSx: { textAlign: 'left', } },

]



export const inquiryOneFilterCol = [
    { header: 'Route', dataKey: 'route', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
    { header: 'Bus No', dataKey: 'busNo', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
    { header: 'Bus Adv', dataKey: 'busAdv', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
    { header: 'Chart Date Time', dataKey: 'dtJourneyDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
    { header: 'Report Generation Date', dataKey: 'reportDate', headerSx: { textAlign: 'left', }, xlCol: { dataType: 'string', dataFormatter: null, colSpan: 3 } },
]
export const inquiryOneColDef = [
    {
        headerName: 'PNR - TKT', field: 'pnr',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 70, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'USER', field: 'user', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 70, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'SEATS', field: 'seatsCount', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '60px' }
    },
    {
        headerName: 'SEATS Nos', field: 'seats', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 70, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Customer', field: 'customer', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Phone', field: 'phone', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '100px' }
    },
    {
        headerName: 'From', field: 'from', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'To', field: 'to', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Pickup', field: 'pickup', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }
    },
    {
        headerName: 'Fare', field: 'fare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '60px' }
    },
    {
        headerName: 'Type', field: 'type', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '80px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },
]

export const inquiryOneTotalColDef = [
    {
        field: "label",
        colSpan: 2,
        headerSx: {
            fontWeight: 600,
            textAlign: "right",
        },
    },
    {
        field: "seatsCount",
        headerSx: {
            textAlign: "right",
            fontWeight: 600,
        },
    },
    {
        field: "",
        colSpan: 6,
    },
    {
        field: "fare",
        headerSx: {
            textAlign: "right",
            fontWeight: 600,
        },
    },
    {
        field: "",
        colSpan: 1,
    },
    {
        field: "",
        headerSx: {
            textAlign: "left",
            fontWeight: 600,
        },
    },
];

export const inquiryTwoColDef = [
    {
        headerName: 'Ticket No', field: 'PNRNo',
        pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 20, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Seats', field: 'SeatCount', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 60, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '50px' }
    },
    {
        headerName: 'Seat Nos', field: 'AllSeats', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '50px' }
    },
    {
        headerName: 'Customer', field: 'CustomerName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 40 }, headerSx: { textAlign: 'left', width: '60px' }
    },
    {
        headerName: 'Phone', field: 'CustomerPhone1', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'From-To', field: 'RouteName', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Pickup', field: 'PickupAddress', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '140px' }
    },
    {
        headerName: 'Status', field: 'TypeofBooking', pdfColSx: {
            halign: 'left', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '80px' }
    },
    {
        headerName: 'Total', field: 'TotalFare', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 30, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '50px' }
    },
    {
        headerName: 'Payment Mode', field: 'PaymentModeName', pdfColSx: {
            halign: 'right', fontSize: 12, valign: 'middle', fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 80, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'right', width: '120px' }
    },
]
